import { render, staticRenderFns } from "./DetailBillHistory.vue?vue&type=template&id=299b6c4f&"
import script from "./DetailBillHistory.vue?vue&type=script&lang=js&"
export * from "./DetailBillHistory.vue?vue&type=script&lang=js&"
import style0 from "./DetailBillHistory.vue?vue&type=style&index=0&id=299b6c4f&prod&lang=css&"
import style1 from "./DetailBillHistory.vue?vue&type=style&index=1&id=299b6c4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports